<template>
  <div class="min-h-full">
    <PageHeader title="Leverage Analysis" :breadcrumbs="[{ label: 'Beta' }]" />
    <div class="p-6">
      <Portfolio_Analysis />
    </div>
  </div>
</template>

<script>
import Portfolio_Analysis from '@/components/Portfolio_Management/Portfolio_Analysis_v2.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'LeverageAnalysisTab',
  components: {
    Portfolio_Analysis,
    PageHeader,
  },
}
</script>
